import React from "react";
const IconCartQuantity = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="21" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21" {...props}>
    <path
      d="M7 7.38889C7 5.24111 8.34315 3.5 10 3.5C11.6569 3.5 13 5.24111 13 7.38889M4 7.38889H16L15 17.5H5L4 7.38889Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
    <rect x="8" y="10.5" width="12" height="10" rx="5" fill="white" />
    <path d="M14 12.375V19.375" stroke="currentColor" strokeWidth="1.6" />
    <path d="M10.5 15.8809H17.5" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);
export default IconCartQuantity;
